export default __webpack_public_path__ + "src/assets/newsletter.47ed57a6488bda0174f97ebc29fd3b9f.svg";